<template>
  <v-container class="pa-0 ma-0">
    <v-expansion-panel :disabled="disabled">
      <slot name="header">
        <v-expansion-panel-header v-slot="{ }" class="pt-0 pb-0 pl-0 pr-4">
          <v-list-item font-weight-black class="darkerheader pr-1">
            <v-list-item-icon class="uplifted mr-4 my-auto">
              <v-icon size="20" v-text="'$customer'" />
            </v-list-item-icon>
            <v-list-item-content v-if="CustomerData">
              <h3 v-if="CustomerData && CustomerData.Name" v-html="searchhighlight(CustomerData.Name, searchterm, true)"
                class="useThemeTextColor nowrapheader font-weight-bold" />
            </v-list-item-content>
            <v-list-item-action class="my-auto">

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="viewCustomerInNewTab()" icon v-bind="attrs" v-on="on">
                    <v-icon size="18">mdi-open-in-new</v-icon>
                  </v-btn>
                </template>
                <span v-text="$t('servicesystem.common_objects.document.open_in_new_tab')" />
              </v-tooltip>
            </v-list-item-action>
          </v-list-item>
        </v-expansion-panel-header>
      </slot>

      <v-expansion-panel-content>
        <v-divider />
        <v-container v-if="CustomerData" class="py-2 px-0">
          <v-row no-gutters class="px-5">
            <v-col>
              <QTextField :value="CustomerData.Id" :label="$t('servicesystem.common_objects.customer.customer_number')"
                :disabled="true">
              </QTextField>
            </v-col>
            <v-col>
              <QTextField :value="CustomerData.OrganisationNumber"
                :label="$t('servicesystem.common_objects.customer.organization_number')" :disabled="true">
              </QTextField>
            </v-col>
            <v-col>
              <switch-li :value="CustomerData.FreeFromVat"
                :label="$t('servicesystem.common_objects.customer.free_from_vat')">
              </switch-li>
            </v-col>
          </v-row>
          <FieldPrinter v-if="CustomerData && AddedFields && AddedFields.CustomerDetails" :sourceObject="CustomerData"
            :fieldList="AddedFields.CustomerDetails" :groupRestriction="'CustomerDetails'">
          </FieldPrinter>
        </v-container>
      </v-expansion-panel-content>
      <v-divider />
      <ParentCustomerCard :id="CustomerData ? CustomerData.ParentId : null" />
    </v-expansion-panel>
  </v-container>
</template>


<script>
//import EditLi from "@/components/Inputs/EditableListItem.vue";
import SwitchLi from "@/components/Inputs/SwitchListItem.vue";
//import AreaLi from "@/components/Inputs/AreaListItem.vue";
import ParentCustomerCard from "@/views/job/newjob/cards/customer/ParentCustomerCard.vue";

import FieldPrinter from "@/components/SingleUse/FieldPrinter.vue";

export default {
  name: "CustomerPreview",
  props: {
    CustomerData: Object,
  },
  components: {
    //EditLi,
    //AreaLi,
    SwitchLi,
    FieldPrinter,
    ParentCustomerCard,
  },

  data: () => ({
    disabled: false,
  }),

  mounted() { },

  methods: {
    viewCustomerInNewTab() {
      let routeData = this.$router.resolve({ name: "ViewCustomer", params: { customerId: this.CustomerData.Id } });
      window.open(routeData.href, "_blank");
    },
  },

  computed: {
    searchterm() {
      return this.$store.state.filtersearchregex;
    },
  },

  watch: {},
};
</script>